module.exports = __webpack_public_path__ + "media/application/images/landing_header/underlay_02-cdf2263f1434b48fb12473f594d1b52b.png";